import { openDB } from "idb";

export const dbPromise = openDB("filingsDB", 2, {
  upgrade(db) {
    const tabs = [
      "Filings_Edgar",
      "Filings_Sections",
      "Filings_Categories",
      "Filings_Cris",
      "Filings_Sedar",
      "Filings_Tanshin",
      "Filings_Yuho",
      "Filings_Obi",
      "Filings_China",
      "Filings_Dart",
      "Filings_Bridge",
      "Filings_SecNonEdgar",
      "Filings_Italy",
      "Filings_Muni",
      "Filings_Segmentation"
    ];
    for (const tab of tabs) {
      if (!db.objectStoreNames.contains(tab)) {
        db.createObjectStore(tab, { keyPath: "content" });
      }
    }
  },
});

export async function addItem(tab, items) {
  const db = await dbPromise;
  for(let item of items){
    db.put(tab, item)
  }
  return ;
}

export async function getAllItems(tab) {
  const db = await dbPromise;
  return db.getAll(tab);
}

export async function getItem(tab, id) {
  const db = await dbPromise;
  return db.get(tab, id);
}

export async function deleteItem(tab, id) {
  const db = await dbPromise;
  return db.delete(tab, id);
}

export async function clearStore(tab) {
  const db = await dbPromise;
  return db.clear(tab);
}

export async function clearAllStores() {
  const db = await dbPromise;
  const storeNames = db.objectStoreNames;
  for (const storeName of storeNames) {
    await db.clear(storeName);
  }
  return true;
}

